import type { RouteLocationNormalized } from 'vue-router'
import { apiCall, apiCallSsr } from '~/composables/apiCall'
import { translatedQuery, webshopSettingsQuery } from '~/graphql/queries/settings.query.gql'
import { webshopSettings } from '~/store/webshopSettings'

function extractLanguageFromRoute (route: RouteLocationNormalized) {
    const routeNameFragments = (route?.name as string)?.split('___')
    return routeNameFragments && routeNameFragments.length === 2 ? routeNameFragments[1] : null
}

export default defineNuxtRouteMiddleware(async (to, from) => {
    // TODO there is an SSR issue because Apollo does not know how to distinguish between the two different webshopSettings queries (since they are both the same) and it doesnt know what to write to its cache
    // TODO we should throw an error if the domain is frontend.foodticket.dev
    const toRouteLang = extractLanguageFromRoute(to)
    const fromRouteLang = extractLanguageFromRoute(from)
    if (webshopSettings().currentHost === null) {
        const { public: { foodticketHost } } = useRuntimeConfig()
        const host = import.meta.client ? foodticketHost || window.location.host : foodticketHost || useRequestHeaders()['x-forwarded-host'] || useRequestHeaders().host
        webshopSettings().setCurrentHost(host)
    }
    if (toRouteLang !== null) {
        webshopSettings().setCurrentLang(toRouteLang)
    }
    if (Object.keys(webshopSettings().global).length === 0) {
        const settings = await apiCallSsr(webshopSettingsQuery, 'publicSettings', {}, true)
        webshopSettings().setGlobalSettings(settings)
    }
    if (Object.keys(webshopSettings().translated).length === 0 || ((!import.meta.server && toRouteLang !== fromRouteLang) && fromRouteLang !== null)) {
        const translated = await apiCall(translatedQuery, 'publicSettings', {}, false)
        webshopSettings().setTranslated(translated)
    }
    return true
})
